<template>
  <section class="profile-area__wrap" data-scroll-section>
    <div class="profile-area">
      <div class="profile-area__inner l-container">
        <CSectionTitle textColor="white">
          <template v-slot:titleEn>
            PROFILE
          </template>
          <template v-slot:titleJa>
            プロフィール
          </template>
          <template v-slot:bg> </template>
        </CSectionTitle>

        <div class="profile">
          <div class="profile__photo">
            <div class="profile__photo-in">
              <img
                data-scroll
                data-scroll-speed="0.2%"
                :src="require(`@/assets/${data.slug}/profile-${data.slug}.jpg`)"
                alt=""
              />
            </div>
          </div>
          <div class="profile__body">
            <div class="profile__body__in">
              <div class="profile__body__contents">
                <h3>{{ data.name }}</h3>
                <p>
                  {{ data.desc }}
                </p>
              </div>
              <svg
                class="profile__body__tri"
                width="451"
                height="199"
                viewBox="0 0 451 199"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g filter="url(#filter0_d)">
                  <path
                    d="M24 186.599L419 154.099L426.5 36.0987L24 186.599Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <filter
                    id="filter0_d"
                    x="0"
                    y="0.0986938"
                    width="450.5"
                    height="198.5"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    />
                    <feOffset dy="-12" />
                    <feGaussianBlur stdDeviation="12" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import CSectionTitle from '@/components/C-SectionTitle.vue'

export default {
  props: {
    data: {
      // require: true,
    }
  },
  components: { CSectionTitle }
}
</script>

<style lang="scss" scoped>
.profile-area {
  background: var(--main-color);
  transform: skewY(-6deg);
  padding: 10rem 0 14rem;
  @media screen and (max-width: $breakpoint-mobile) {
    padding: 4rem 0 8rem;
  }

  &__inner {
    transform: skewY(6deg);
  }

  .profile {
    display: flex;
    justify-content: center;
    @media screen and (max-width: $breakpoint-mobile) {
      flex-direction: column;
    }
    &__photo {
      transform: skewY(-6deg) translate(5rem, 0px);
      overflow: hidden;
      width: 50rem;
      height: 30rem;
      position: relative;
      z-index: 9;
      @media screen and (max-width: $breakpoint-mobile) {
        width: 100%;
        height: 24rem;
        transform: skewY(-6deg) translate(0, 0);
      }
    }

    &__photo-in {
      position: absolute;
      transform: skewY(6deg);
      height: 40rem;
      top: 50%;
      transform: translate(0, -50%) skewY(6deg);
      @media screen and (max-width: $breakpoint-mobile) {
        height: 30rem;
      }

      img {
        width: 100%;
        height: 120%;
        object-fit: cover;
      }
    }

    &__body {
      width: 70rem;
      transform: translate(-5rem, 0px);
      @media screen and (max-width: $breakpoint-mobile) {
        width: 100%;
        transform: translate(0, 0);
      }
      &__in {
        transform: skewY(-6deg);
        background: #fff;
        padding: 6rem 6rem 6rem 14rem;
        text-align: left;
        font-size: 1.6rem;
        @media screen and (max-width: $breakpoint-mobile) {
          padding: 3rem 2.4rem 4rem;
        }
      }

      &__contents {
        transform: skewY(6deg);
        h3 {
          font-size: 3rem;
          color: var(--main-color);
          margin: 0 0 1.2rem;
          @media screen and (max-width: $breakpoint-mobile) {
            font-size: 2rem;
          }
        }
        p {
          font-size: 1.6rem;
          font-weight: 600;
          @media screen and (max-width: $breakpoint-mobile) {
            font-size: 1.3rem;
          }
        }
      }

      &__tri {
        position: absolute;
        right: -5rem;
        bottom: -8rem;
        transform: rotate(8deg);
        z-index: -9;
        @media screen and (max-width: $breakpoint-mobile) {
          width: 30rem;
        }
      }
    }
  }
}
</style>
